export const BREADER_API = '/api/breader';

export type TourFilterOptions = {
  customers: { id: number; oss_code: string }[];
  readers: { id: number; name: string }[];
  cities: string[];
};
